<template>
  <ShortcutWrapper :nShortcutRequiredClaim="UserClaims.GlobalAdmin" @n-shortcut="mutate(null, 'create')">
    <v-container fluid id="species-settings">

      <Dialog
      :maxWidth="deleting ? '400px' : ''"
      :stateId="dialogId"
      @click:outside="close"
      @dialog-closing="close"
      @close="close">

        <ConfirmDelete
        v-if="deleting"
        :title="$t('species')"
        @delete="performDelete"
        @cancel-delete="close"/>

        <SpeciesForm
        v-else
        :propSpecies="species"
        @species-mutated="refresh"/>

      </Dialog>

      <DataTable
      defaultHeight="calc(100vh - 620px)"
      :items="allSpecies"
      :headers="headers"
      :customCells="customCells"
      :actions="tableActions"
      :loading="speciesLoading"
      :showDense="false"
      @refresh="refresh"
      @new-species="mutate(null, 'create')"
      style="max-width: 1000px;">

        <template #actions="{ item }">
          <Icon
          icon="mdi-delete-forever"
          :tooltipText="$t('delete')"
          @icon-clicked="mutate(item, 'delete')"
          :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
          elementId="species-delete"/>
        </template>

      </DataTable>

    </v-container>
  </ShortcutWrapper>
</template>
<script>
import ProductHeaders from '@/headers/Product'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { UserClaims } from '@/utils/Enumerations.js'
import { uniqueDialogId } from '@/utils/componentHelpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SpeciesSettings',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    ShortcutWrapper: () => import('@/components/core/ShortcutWrapper.vue'),
    Dialog: () => import('@/components/Dialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    SpeciesForm: () => import('@/components/settings-components/product-settings/species/SpeciesForm.vue'),
    ConfirmDelete: () => import('@/components/helper/ConfirmDelete.vue')
  },

  data: () => ({
    UserClaims,
    dialogId: uniqueDialogId('species-dialog'),
    deleting: false,
    species: null
  }),

  async mounted () {
    await this.fetchSpecies()
  },

  computed: {
    ...mapGetters('species', ['allSpecies', 'speciesLoading']),
    headers () {
      return ProductHeaders.speciesHeaders()
    },

    tableActions () {
      return [
        {
          icon: 'mdi-refresh',
          text: this.$t('refresh'),
          actionName: 'refresh'
        },
        {
          icon: 'mdi-plus',
          text: this.$t('newSpecies'),
          actionName: 'new-species',
          disabled: !userAssignedClaim(UserClaims.GlobalAdmin)
        }
      ]
    },

    customCells () {
      return [
        {
          slotName: 'actions',
          value: 'actions'
        }
      ]
    }
  },

  methods: {
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),
    ...mapActions('species', ['fetchSpecies', 'deleteSpecies']),
    userAssignedClaim,

    refresh () {
      this.close()
      this.loading = true
      this.fetchSpecies().finally(() => {
        this.loading = false
      })
    },

    mutate (species, mutationType) {
      this.species = JSON.parse(JSON.stringify(species))
      if (mutationType === 'delete') this.deleting = true
      this.openOrUpdateDialog(this.dialogId)
    },

    close () {
      this.deleting = false
      this.closeDialogsAtOrAbove(this.dialogId)
      this.species = undefined
    },

    async performDelete () {
      await this.deleteSpecies(this.species.speciesId)
      this.refresh()
    }
  }
}
</script>
